export { MFAType } from '@/components/mfaForm/MFACodeForm.types';

export enum MFAFlow {
  REGISTER = 'REGISTER',
  LOGIN = 'LOGIN',
}
